import { render, staticRenderFns } from "./CustomPaymentDetails.vue?vue&type=template&id=3b7a8eaa&scoped=true&"
import script from "./CustomPaymentDetails.vue?vue&type=script&lang=js&"
export * from "./CustomPaymentDetails.vue?vue&type=script&lang=js&"
import style0 from "./CustomPaymentDetails.vue?vue&type=style&index=0&id=3b7a8eaa&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7a8eaa",
  null
  
)

export default component.exports